
import { tenderPhases } from '@/assets/mappings.json';

export default {
  props: {
    tenderId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      tenderPhases,

      publications: []
    };
  },

  async fetch () {
    const platforms = await this.$axios.$get(`/publicationtimeline?tenderId=${this.tenderId}`);

    this.publications = platforms.map((platform) => {
      let foundFirstPrematurelyClosed = false;

      return {
        name: platform.name,
        timeline: platform.timeline.map((x) => {
          if (x.isPrematurelyClosed && !foundFirstPrematurelyClosed) {
            foundFirstPrematurelyClosed = true;
            return x;
          }

          return { ...x, isPrematurelyClosed: false };
        })
      };
    });
  },

  computed: {
    filteredPublications () {
      return this.publications.map((publication) => {
        return {
          name: publication.name,
          timeline: publication.timeline.filter(
            x => x.phase !== 'Unknown' || !publication.timeline.some(y => y.phase !== 'Unknown' && x.publicationUrl === y.publicationUrl)
          )
        };
      });
    }
  },

  methods: {
    open (url) {
      window.open(url, '_blank');
    }
  }
};
